import { render, staticRenderFns } from "./PersonalInfoBlock.vue?vue&type=template&id=03d99870&scoped=true"
import script from "./PersonalInfoBlock.vue?vue&type=script&lang=js"
export * from "./PersonalInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d99870",
  null
  
)

export default component.exports